/**
 * History template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'History';

const trolleyDom = document.querySelector(`[data-trolley]`);

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initStaggerReveal();
	initTrolley();
}

/**
 * initStaggerReveal - Initialize the image reveal
 */
const initStaggerReveal = () => {
	Logger.log(`${NAME} > initStaggerReveal`);

	gsap.set(`[data-stagger-reveal]`, { opacity: 0, y: 100 });

	ScrollTrigger.batch(`[data-stagger-reveal]`, {
		onEnter: (batch) =>
			gsap.to(batch, {
				duration: 0.75,
				opacity: 1,
				y: 0,
				stagger: 0.3
			}),
		start: "top 95%"
	});

}

/**
 * initTrolley - Initialize the trolley
 */
const initTrolley = () => {
	Logger.log(`${NAME} > initTrolley`);

	if (!trolleyDom) return;

	// Determine end by screen height
	const screenHeight = window.innerHeight;
	let end = 55;
	if (screenHeight < 500) {
		end = 90
	}

	gsap.to(trolleyDom, {
		scrollTrigger: {
			trigger: trolleyDom,
			scrub: false,
			start: "top 40px",
			endTrigger: `.history-future`,
			end: `top 100px`,
			pin: true,
			pinSpacing: false,
			toggleActions: "play none none reverse",
			// markers: true
		},
		scale: 0.5,
		duration: 0.2
	});


}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
